import { useId, useState } from "react";
import { IconChevronRightLine } from "@hamlak/ui";
import { COMPANY } from "@/config/company";
import { LINKS, type DocLinkKey } from "@/config/links";
import { t } from "@/i18n/ko";
import { platform } from "@/platform";
import "./homeFooter.css";

/** 푸터 링크 순서(AC0-230): 이용약관 | 환불정책 | 운영정책 | 개인정보처리방침 | 청소년 보호정책 */
const FOOTER_LINKS: readonly { key: DocLinkKey; label: () => string }[] = [
  { key: "terms", label: () => t("home.footer.terms") },
  { key: "refundPolicy", label: () => t("home.footer.refundPolicy") },
  { key: "operationPolicy", label: () => t("home.footer.operationPolicy") },
  { key: "privacy", label: () => t("home.footer.privacy") },
  { key: "youthPolicy", label: () => t("home.footer.youthPolicy") },
];

/**
 * 홈 스크롤 맨 끝 사업자 정보 푸터(AC0-230, 웹·앱 공통). 구분선 → "© 회사명" 토글(기본 펼침) → 사업자 정보 → 약관 링크 5종.
 * 링크는 설정 화면과 같이 platform.browser.open(앱 Custom Tabs, 웹 새 탭).
 */
export function HomeFooter() {
  const [open, setOpen] = useState(true);
  const infoId = useId();

  const openLink = (key: DocLinkKey) => {
    void platform.browser.open(LINKS[key]);
  };

  return (
    <footer className="home-footer" data-testid="home-footer">
      <button type="button" className="home-footer__toggle" aria-expanded={open} aria-controls={infoId} onClick={() => setOpen((v) => !v)}>
        {t("home.footer.copyright", { company: COMPANY.name })}
        <IconChevronRightLine size={16} className={open ? "home-footer__chevron home-footer__chevron--open" : "home-footer__chevron"} />
      </button>
      <div id={infoId} className="home-footer__info" hidden={!open}>
        <p>{COMPANY.address}</p>
        <p className="home-footer__row">
          <span>{t("home.footer.ceo", { name: COMPANY.ceo })}</span>
          <span>{t("home.footer.bizRegNo", { no: COMPANY.bizRegNo })}</span>
        </p>
        <p>{t("home.footer.mailOrderNo", { no: COMPANY.mailOrderNo })}</p>
        <p className="home-footer__row">
          <span>{t("home.footer.csPhone", { phone: COMPANY.csPhone })}</span>
          <span>{t("home.footer.email", { email: COMPANY.email })}</span>
        </p>
      </div>
      <nav className="home-footer__row home-footer__links" aria-label={t("home.footer.links")}>
        {FOOTER_LINKS.map((l) => (
          <button key={l.key} type="button" className="home-footer__link" onClick={() => openLink(l.key)}>
            {l.label()}
          </button>
        ))}
      </nav>
    </footer>
  );
}
